import React, { useEffect, useState } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { GoogleKeys } from "../../../../config/google";
import SearchMapComponent from "../../../../Components/mapView/searchMap";
// import './autocomplete.css'; // Path to your CSS file

const libraries = ["places"]; // Required for search suggestions

const PropertyLocationForm = ({ refs, formData, setFormData }) => {
    console.log(formData, "formData")
    // 🔹 Get API key from environment variables
    const googleMapsApiKey = GoogleKeys.GOOGLE_MAPS_API_KEY


    const [autocomplete, setAutocomplete] = useState(null);
    const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);


    const [allLandmarks, setAllLandmarks] = useState([]);
    const [customLandmark, setCustomLandmark] = useState({ name: "", distance: "" });

    // 🔹 Universal HandleChange Function for Nested State Updates
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        const keys = name.split("."); // Handle nested structure dynamically

        setFormData((prevState) => {
            let updatedState = { ...prevState };
            let nestedField = updatedState;

            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i];
                if (!nestedField[key]) nestedField[key] = {};
                nestedField = nestedField[key];
            }

            nestedField[keys[keys.length - 1]] = value;

            return { ...updatedState };
        });
    };


    const getDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371;
        const dLat = ((lat2 - lat1) * Math.PI) / 180;
        const dLng = ((lng2 - lng1) * Math.PI) / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos((lat1 * Math.PI) / 180) *
            Math.cos((lat2 * Math.PI) / 180) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return {
            meters: Math.round(distance * 1000),
            kilometers: distance.toFixed(2),
        };
    };


    const fetchNearbyLandmarks = (lat, lng) => {
        console.log("Google API Status:", window.google?.maps);
        console.log("Fetching nearby landmarks for:", lat, lng);
        console.log("Google API Loaded:", !!window.google?.maps);

        if (!window.google || !window.google.maps) {
            console.error("Google Maps API not loaded!");
            return;
        }

        const service = new window.google.maps.places.PlacesService(document.createElement("div"));

        // 🔹 Property Type ke hisaab se multiple place types
        const propertyType = formData?.basicDetails?.propertyType;

        const categoryMapping = {
            Residential: ["school", "hospital", "park", "grocery_or_supermarket", "restaurant"], // 🏡 Nearby places for homes
            Commercial: ["shopping_mall", "bank", "restaurant", "cafe", "gym"], // 🏢 Businesses & shops
            agriculture: ["natural_feature", "park", "farm"], // 🌾 Agriculture-related
        };

        // Agar mapping nahi mili toh default ["point_of_interest"]
        const selectedCategories = categoryMapping[propertyType] || ["point_of_interest"];

        // 🔥 Fetching places using multiple types
        let allResults = [];
        let pendingRequests = selectedCategories.length;

        selectedCategories.forEach((type) => {
            const request = {
                location: new window.google.maps.LatLng(lat, lng),
                radius: 2000, // 🔥 Radius bada kar diya (5KM)
                type: type, // 🔥 Dynamic type use kar rahe hain
            };

            service.nearbySearch(request, (results, status, pagination) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && results) {
                    allResults = [...allResults, ...results];

                    // Agar 10+ results chahiye toh next page fetch karo
                    if (pagination?.hasNextPage) {
                        pagination.nextPage();
                    }
                }

                pendingRequests--;

                // Saari requests complete hone ke baad state update karein
                if (pendingRequests === 0) {
                    const uniqueLandmarks = Array.from(new Set(allResults.map((place) => place.place_id)))
                        .map((id) => allResults.find((place) => place.place_id === id))
                        .slice(0, 10); // 🔥 Sirf 10 unique results return karenge

                    const landmarks = uniqueLandmarks.map((place) => ({
                        name: place.name,
                        destination: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() },
                        distance: getDistance(lat, lng, place.geometry.location.lat(), place.geometry.location.lng()),
                        selected: true,
                    }));

                    setAllLandmarks(landmarks);

                    setFormData((prevData) => ({
                        ...prevData,
                        locationDetails: {
                            ...prevData.locationDetails,
                            nearbyLandmarks: landmarks,// 👈 Pre-selecting them in form data
                        },
                    }));
                }
            });
        });
    };


    // ✅ Toggle function update for selected landmarks
    const toggleLandmarkSelection = (index) => {
        setAllLandmarks((prevLandmarks) => {
            const updatedLandmarks = [...prevLandmarks];
            updatedLandmarks[index].selected = !updatedLandmarks[index].selected;

            setFormData((prevData) => ({
                ...prevData,
                locationDetails: {
                    ...prevData.locationDetails,
                    nearbyLandmarks: updatedLandmarks.filter((lm) => lm.selected),
                },
            }));

            return updatedLandmarks;
        });
    };

    const addCustomLandmark = () => {
        if (customLandmark.name && customLandmark.distance) {
            const newLandmark = {
                name: customLandmark.name,
                destination: null,
                distance: {
                    meters: customLandmark.distance * 1000,
                    kilometers: customLandmark.distance,
                },
                selected: true,
            };

            setAllLandmarks([...allLandmarks, newLandmark]);

            setFormData((prevData) => ({
                ...prevData,
                locationDetails: {
                    ...prevData.locationDetails,
                    nearbyLandmarks: [...prevData.locationDetails.nearbyLandmarks, newLandmark],
                },
            }));

            setCustomLandmark({ name: "", distance: "" });
        }
    };



    // Jab user place select karega, yeh function address details ko set karega
    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();
            if (place.geometry) {
                const addressComponents = place.address_components;
                let newLocationDetails = { ...formData.locationDetails };

                // Get the Latitude and Longitude
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();

                // Update locationDetails with lat and lng
                newLocationDetails.lat = lat;
                newLocationDetails.lng = lng;


                addressComponents.forEach((component) => {
                    const types = component.types;

                    if (types.includes("locality")) {
                        newLocationDetails.city = component.long_name; // City Name
                    }
                    if (types.includes("sublocality") || types.includes("sublocality_level_1")) {
                        newLocationDetails.locality = component.long_name; // Locality
                    }
                    if (types.includes("neighborhood") || types.includes("political")) {
                        newLocationDetails.subLocality = component.long_name; // Sub Locality
                    }
                    if (types.includes("route")) {
                        newLocationDetails.apartmentSociety = component.long_name; // Apartment/Society
                    }
                    if (types.includes("street_number")) {
                        newLocationDetails.houseDetails = component.long_name; // House No./Flat No.
                    }
                });

                // Search location field ko bhi update karo
                newLocationDetails.searchLocation = place.formatted_address;

                setFormData({
                    ...formData,
                    locationDetails: newLocationDetails,
                });
                fetchNearbyLandmarks(lat, lng);
            }
        }
    };


    // ✅ Ensure Google API is loaded
    useEffect(() => {
        if (window.google && window.google.maps) {
            setIsGoogleLoaded(true);
        }
    }, [window.google]);

    const onLoad = () => {
        setIsGoogleLoaded(true);
        console.log("✅ Google Maps API Loaded Successfully!");
    };


    return (
        <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={libraries} onLoad={onLoad}>
            <style>
                {`
          /* Custom Styling for Autocomplete Dropdown */
          .pac-container {
            z-index: 1000 !important;
            max-width: 100% !important;
            width: auto !important;
            background-color: white !important;
            border: 1px solid #ccc !important;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            top: 590px !important;
          }

          /* Adjust the individual items in the dropdown */
          .pac-item {
            padding: 10px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          /* Hover effect for items */
          .pac-item:hover {
            background-color: #f0f0f0;
          }

          /* Focused item styling */
          .pac-item.pac-item-selected {
            background-color: #e0e0e0;
          }
        `}
            </style>
            <fieldset className="border border-gray-300 p-4 rounded-md">
                <legend className="text-lg font-semibold px-2">Where is your property located?</legend>
                <label className="block text-sm font-medium text-gray-700">
                    An accurate location helps you connect with the right buyers
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    {/* 🔹 Autocomplete Wrapper to Fix Dropdown Position */}
                    <div className="relative w-full">
                        <label className="block text-sm font-medium text-gray-700">Search Location</label>
                        <Autocomplete
                            onLoad={setAutocomplete}
                            onPlaceChanged={onPlaceChanged}
                            options={{ componentRestrictions: { country: "IN" } }}// Restrict to India
                        >
                            <input
                                type="text"
                                name="locationDetails.searchLocation"
                                value={formData.locationDetails.searchLocation}
                                onChange={handleChange1}
                                placeholder="Enter nearby landmarks or areas"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                style={{
                                    position: "relative", // Ensure input stays above the dropdown
                                    zIndex: 10
                                }} // Ensures input is above dropdown
                            />
                        </Autocomplete>
                    </div>





                    <div>
                        <label className="block text-sm font-medium text-gray-700">City</label>
                        <input
                            type="text"
                            name="locationDetails.city"
                            value={formData.locationDetails.city}
                            onChange={handleChange1}
                            placeholder="Enter the city name"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Locality</label>
                        <input
                            type="text"
                            name="locationDetails.locality"
                            value={formData.locationDetails.locality}
                            onChange={handleChange1}
                            placeholder="Enter the locality name"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sub Locality (Optional)</label>
                        <input
                            type="text"
                            name="locationDetails.subLocality"
                            onChange={handleChange1}
                            value={formData.locationDetails.subLocality}
                            placeholder="Enter the sub locality (if any)"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Apartment/Society</label>
                        <input
                            type="text"
                            name="locationDetails.apartmentSociety"
                            onChange={handleChange1}
                            value={formData.locationDetails.apartmentSociety}
                            placeholder="Enter the apartment or society name"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            House No./Floor No./Flat No./Plot No. (Optional)
                        </label>
                        <input
                            type="text"
                            name="locationDetails.houseDetails"
                            onChange={handleChange1}
                            value={formData.locationDetails.houseDetails}
                            placeholder="Enter the house, floor, flat, or plot number"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                        />
                    </div>





                </div>

                <div className="mt-5">
                    <label className="block text-[16px] font-medium text-gray-700">Nearby Landmarks</label>
                    <div className="mt-1 p-2 border border-gray-300 rounded-md shadow-sm max-h-48 overflow-y-auto">
                        {allLandmarks.length > 0 ? (
                            allLandmarks.map((landmark, index) => (
                                <label key={index} className="flex items-center space-x-2 text-sm text-gray-600">
                                    <input
                                        type="checkbox"
                                        checked={landmark.selected}
                                        onChange={() => toggleLandmarkSelection(index)}
                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                                    />
                                    <span>
                                        📍 {landmark.name} - <strong>{landmark.distance.kilometers} km</strong>
                                    </span>
                                </label>
                            ))
                        ) : (
                            <p className="text-gray-500 text-sm text-center py-2">🚫 No landmarks found near this location.</p>
                        )}
                    </div>

                    <div className="mt-2 flex space-x-2">
                        <input
                            type="text"
                            placeholder="Custom Landmark Name"
                            value={customLandmark.name}
                            onChange={(e) => setCustomLandmark({ ...customLandmark, name: e.target.value })}
                            className="border p-2 rounded w-2/3"
                        />
                        <input
                            type="number"
                            placeholder="Distance (km)"
                            value={customLandmark.distance}
                            onChange={(e) => setCustomLandmark({ ...customLandmark, distance: e.target.value })}
                            className="border p-2 rounded w-1/3"
                        />
                        <button onClick={addCustomLandmark} type="button" className="bg-blue-500 text-white p-2 rounded">Add</button>
                    </div>
                </div>

            </fieldset>
        </LoadScript>
    );
};

export default PropertyLocationForm;
